import React from 'react'

const Jva_tog = () => {
    return (
        <div className='container'>
            <td>
 

 <h1 class="h1">Java Program to tOGGLE each word in String</h1>
 <p>We can tOGGLE each word of a string by the help of split(), toLowerCase(), toUpperCase() and substring() methods.
   By the help of split("\\s") method, we can get all words in an array. To get the first character, we can use
   substring() or charAt() method.</p>
 <p>Let's see the example to tOGGLE each word in a string.</p>

 <p class="filename">File: StringFormatter.java</p>
 <div class="containers">
   <div class="dp-highlighter">
     
     <ul start="1" class="dp-j">
       <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
             class="keywords">class</span><span>&nbsp;StringFormatter&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
       <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
             class="keywords">static</span><span>&nbsp;String&nbsp;toggle(String&nbsp;str)&#123;&nbsp;&nbsp;</span></span>
       </li>
       <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;words[]=str.split(<span
             class="string">"\\s"</span><span>);&nbsp;&nbsp;</span></span></li>
       <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;toggle=<span
             class="string">""</span><span>;&nbsp;&nbsp;</span></span></li>
       <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
             class="keywords">for</span><span>(String&nbsp;w:words)&#123;&nbsp;&nbsp;</span></span></li>
       <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;first=w.substring(<span
             class="number">0</span><span>,</span><span class="number">1</span><span>);&nbsp;&nbsp;</span></span></li>
       <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;afterfirst=w.substring(<span
             class="number">1</span><span>);&nbsp;&nbsp;</span></span></li>
       <li class="">
         <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;toggle+=first.toLowerCase()+afterfirst.toUpperCase()+<span
             class="string">"&nbsp;"</span><span>;&nbsp;&nbsp;</span></span></li>
       <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
       <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
             class="keywords">return</span><span>&nbsp;toggle.trim();&nbsp;&nbsp;</span></span></li>
       <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
       <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
     </ul>
   </div>
 </div>
 <p class="filename">File: TestStringFormatter.java</p>
 <div class="containers">
   <div class="dp-highlighter">
     
     <ul start="1" class="dp-j">
       <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
             class="keywords">class</span><span>&nbsp;TestStringFormatter&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
       <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
             class="keywords">static</span><span>&nbsp;</span><span
             class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
       <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(StringFormatter.toggle(<span
             class="string">"my&nbsp;name&nbsp;is&nbsp;khan"</span><span>));&nbsp;&nbsp;</span></span></li>
       <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(StringFormatter.toggle(<span
             class="string">"I&nbsp;am&nbsp;sonoo&nbsp;jaiswal"</span><span>));&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
       </li>
       <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
       <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
     </ul>
   </div>
 </div>

 <p>Output:</p>
 <div class="output">
   <pre>mY nAME iS kHAN <br/>
 i aM sONOO jAISWAL
 </pre>
 </div>


 
</td>
        </div>
    )
}

export default Jva_tog
